import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationKo from "./ko/translation.json";
import translationEn from "./en/translation.json";

i18n.use(initReactI18next).init({
  resources: {
    ko: {
      translation: translationKo,
    },
    en: {
      translation: translationEn,
    },
  },
  lng: "ko",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
